module.exports = "<iframe\r\n  [src]=\"url\"\r\n  frameborder=\"0\"\r\n  height=\"1500px\"\r\n  width=\"1600px\">\r\n</iframe>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/pregled-avansa/pregled-avansa.component.html
// module id = ./src/app/pages/pregled-avansa/pregled-avansa.component.html
// module chunks = main